<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="USER_CSV_LABELS[UserCsvKeys.schoolIdOrEmail]"
		[controlName]="UserCsvKeys.schoolIdOrEmail"
		[placeholder]="USER_CSV_LABELS[UserCsvKeys.schoolIdOrEmail]"
		[required]="form.get(UserCsvKeys.schoolIdOrEmail)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-role-dropdown-field
		[label]="USER_CSV_LABELS[UserCsvKeys.group]"
		[controlName]="UserCsvKeys.group"
		[placeholder]="USER_CSV_LABELS[UserCsvKeys.group]"
		[required]="form.get(UserCsvKeys.group)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="USER_CSV_LABELS[UserCsvKeys.firstName]"
		[controlName]="UserCsvKeys.firstName"
		[placeholder]="USER_CSV_LABELS[UserCsvKeys.firstName]"
		[required]="form.get(UserCsvKeys.firstName)?.hasValidator(Validators.required) ? true : false"
		[minLength]="2"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="USER_CSV_LABELS[UserCsvKeys.lastName]"
		[controlName]="UserCsvKeys.lastName"
		[placeholder]="USER_CSV_LABELS[UserCsvKeys.lastName]"
		[required]="form.get(UserCsvKeys.lastName)?.hasValidator(Validators.required) ? true : false"
		[minLength]="2"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="USER_CSV_LABELS[UserCsvKeys.active]"
		[controlName]="UserCsvKeys.active"
		[required]="form.get(UserCsvKeys.active)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
